var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from 'shared/components/ui';
// this labels Sun/Mon/Tues/etc at top of the date picker
export var WeekdayLabel = function (formattedWeekday) {
    return (_jsx(Text, __assign({ as: "span", fontSize: 16, textColor: "gray.500" }, { children: formattedWeekday.substring(0, 1) })));
};
